import React from 'react';

import BaseIcon, { BaseIconProps } from './BaseIcon';

const ErrorIcon = ({ viewBox, stroke, ...restProps }: BaseIconProps) => (
  <BaseIcon {...restProps} viewBox={viewBox || '0 0 160 160'}>
    <path d="M55 81L67 69" stroke="#2C3D50" strokeWidth="4" strokeLinecap="round" />
    <path d="M67 81L55 69" stroke="#2C3D50" strokeWidth="4" strokeLinecap="round" />
    <path d="M99 81L111 69" stroke="#2C3D50" strokeWidth="4" strokeLinecap="round" />
    <path d="M111 81L99 69" stroke="#2C3D50" strokeWidth="4" strokeLinecap="round" />
    <path
      d="M148 30H18C15.7909 30 14 31.7909 14 34V122C14 124.209 15.7909 126 18 126H148C150.209 126 152 124.209 152 122V34C152 31.7909 150.209 30 148 30Z"
      stroke="#2C3D50"
      strokeWidth="2"
    />
    <ellipse opacity="0.1" cx="82" cy="130" rx="82" ry="4" fill="#2C3D50" />
    <path
      d="M95 95C93.5109 92.2808 89.7458 90.3831 85 90.0517M72 95C72.7038 93.7148 73.9161 92.6131 75.5 91.7736M75.5 91.7736C77.6133 90.6534 80.3883 90 83.5 90C84.0095 90 84.51 90.0175 85 90.0517M75.5 91.7736C75.3333 94.0157 76 98.5 80 98.5C84 98.5 85 92.8678 85 90.0517"
      stroke="#2C3D50"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path d="M14 33C14 31.3431 15.3431 30 17 30H149C150.657 30 152 31.3431 152 33V39H14V33Z" fill="#2C3D50" />
    <circle cx="20" cy="34" r="2" fill="white" />
    <circle cx="26" cy="34" r="2" fill="white" />
    <circle cx="32" cy="34" r="2" fill="white" />
  </BaseIcon>
);

export default ErrorIcon;
